import { isAxiosError } from "axios"

export function getApiErrorMessage(error: unknown, fallback = "Request failed"): string {
  if (!isAxiosError(error)) {
    return error instanceof Error && error.message ? error.message : fallback
  }

  const payload = error.response?.data
  if (!payload || typeof payload !== "object") {
    return error.message?.trim() || fallback
  }

  const record = payload as Record<string, unknown>

  // Prefer the API's standard user-facing field: { response: { message } }
  const response = record.response
  if (response && typeof response === "object") {
    const message = (response as { message?: unknown }).message
    if (typeof message === "string" && message.trim()) {
      return message.trim()
    }
    if (Array.isArray(message) && message.length > 0) {
      return message.map(String).join(", ")
    }
  }

  const data = record.data
  if (data && typeof data === "object") {
    const dataRecord = data as Record<string, unknown>
    if (typeof dataRecord.message === "string" && dataRecord.message.trim()) {
      return dataRecord.message.trim()
    }
    if (typeof dataRecord.responseMessage === "string" && dataRecord.responseMessage.trim()) {
      return dataRecord.responseMessage.trim()
    }
    if (Array.isArray(dataRecord.responseMessage) && dataRecord.responseMessage.length > 0) {
      return dataRecord.responseMessage.map(String).join(", ")
    }
    if (typeof dataRecord.sqlMessage === "string" && dataRecord.sqlMessage.trim()) {
      return dataRecord.sqlMessage.trim()
    }
  }

  if (typeof record.message === "string" && record.message.trim()) {
    return record.message.trim()
  }

  if (Array.isArray(record.message) && record.message.length > 0) {
    return record.message.map(String).join(", ")
  }

  return error.message?.trim() || fallback
}
